import { render, staticRenderFns } from "./Kifu.vue?vue&type=template&id=562d2bfe&scoped=true&"
import script from "./Kifu.vue?vue&type=script&lang=js&"
export * from "./Kifu.vue?vue&type=script&lang=js&"
import style0 from "./Kifu.vue?vue&type=style&index=0&id=562d2bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d2bfe",
  null
  
)

export default component.exports